var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SearchAPIV2Service } from "@ts/common/service/Api/SearchAPIV2Service";
var IS_SEARCH_TOKEN = 'image_search.search_token';
var IS_IMAGE_TOKEN = 'image_search.image_token';
var IS_THUMB = 'image_search.thumb';
var IS_IMAGE = 'image_search.image';
var IS_CROP = 'image_search.crop';
var IS_REOPEN_MODAL = 'image_search.reopen_modal';
var IS_MEDIA_SLUG = 'image_search.media_slug';
var IS_RESUME = 'image_search.resume_after_validation';
var IS_OPEN_ON_LOAD = 'image_search.open_on_load';
var RESUME_TTL_MS = 24 * 60 * 60 * 1000;
var THUMBNAIL_MAX_SIZE = 240;
var STORED_IMAGE_FALLBACK_MAX_SIZE = 1600;
var DENIALS = ['login_required', 'email_not_validated', 'free_limit_reached', 'subscription_required'];
var UNKNOWN_ACCESS = {
    logged: false,
    quotaExceeded: false,
    subscriber: false,
    freeLimit: 0,
    freeUsed: 0,
    email: '',
    resendAvailableIn: 0,
    denial: null,
};
export function toImageSearchDenial(value) {
    return DENIALS.indexOf(value) >= 0 ? value : null;
}
export function getImageSearchAccess() {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, SearchAPIV2Service.searchByImageStatus()];
                case 1:
                    response = _a.sent();
                    if (response.status !== 200) {
                        return [2, UNKNOWN_ACCESS];
                    }
                    return [4, response.json()];
                case 2:
                    data = _a.sent();
                    return [2, {
                            logged: data.logged === true,
                            quotaExceeded: data.quotaExceeded === true,
                            subscriber: data.subscriber === true,
                            freeLimit: Number(data.freeLimit) || 0,
                            freeUsed: Number(data.freeUsed) || 0,
                            email: typeof data.email === 'string' ? data.email : '',
                            resendAvailableIn: Number(data.resendAvailableIn) || 0,
                            denial: toImageSearchDenial(data.denial),
                        }];
                case 3:
                    e_1 = _a.sent();
                    return [2, UNKNOWN_ACCESS];
                case 4: return [2];
            }
        });
    });
}
export function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function () { return reject(reader.error); };
        reader.readAsDataURL(file);
    });
}
export function makeThumbnail(dataUrl, maxSize, crop) {
    if (maxSize === void 0) { maxSize = THUMBNAIL_MAX_SIZE; }
    if (crop === void 0) { crop = null; }
    return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
            var sx = crop ? crop.x1 : 0;
            var sy = crop ? crop.y1 : 0;
            var sw = crop ? Math.max(1, crop.x2 - crop.x1) : img.width;
            var sh = crop ? Math.max(1, crop.y2 - crop.y1) : img.height;
            var ratio = Math.min(1, maxSize / Math.max(sw, sh));
            var canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(sw * ratio));
            canvas.height = Math.max(1, Math.round(sh * ratio));
            var ctx = canvas.getContext('2d');
            if (!ctx) {
                resolve(dataUrl);
                return;
            }
            ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
            try {
                resolve(canvas.toDataURL('image/jpeg', 0.7));
            }
            catch (e) {
                resolve(dataUrl);
            }
        };
        img.onerror = function () { return resolve(dataUrl); };
        img.src = dataUrl;
    });
}
export function getStoredSearchToken() {
    return sessionStorage.getItem(IS_SEARCH_TOKEN);
}
export function getStoredThumbnail() {
    return sessionStorage.getItem(IS_THUMB);
}
export function getStoredImage() {
    return sessionStorage.getItem(IS_IMAGE);
}
export function isStoredLookImageSearch() {
    return sessionStorage.getItem(IS_MEDIA_SLUG) !== null;
}
export function getStoredCrop() {
    var raw = sessionStorage.getItem(IS_CROP);
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw);
    }
    catch (e) {
        return null;
    }
}
export function markModalReopenAfterNavigation() {
    try {
        sessionStorage.setItem(IS_REOPEN_MODAL, '1');
    }
    catch (e) {
    }
}
export function consumeModalReopenAfterNavigation() {
    var pending = sessionStorage.getItem(IS_REOPEN_MODAL) === '1';
    sessionStorage.removeItem(IS_REOPEN_MODAL);
    return pending;
}
export function getStoredImageToken() {
    return sessionStorage.getItem(IS_IMAGE_TOKEN);
}
export function clearStoredImageSearch() {
    sessionStorage.removeItem(IS_SEARCH_TOKEN);
    sessionStorage.removeItem(IS_IMAGE_TOKEN);
    sessionStorage.removeItem(IS_THUMB);
    sessionStorage.removeItem(IS_IMAGE);
    sessionStorage.removeItem(IS_CROP);
    sessionStorage.removeItem(IS_REOPEN_MODAL);
    sessionStorage.removeItem(IS_MEDIA_SLUG);
}
export function runImageSearch(image, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var storedImage, isStoredImage, mediaSlug;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storedImage = getStoredImage();
                    isStoredImage = storedImage !== null && storedImage === image;
                    mediaSlug = isStoredImage ? sessionStorage.getItem(IS_MEDIA_SLUG) : null;
                    return [4, searchWith(mediaSlug !== null ? { mediaSlug: mediaSlug } : { image: image }, isStoredImage ? getStoredImageToken() : null, options)];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
export function runLookImageSearch(mediaSlug, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, searchWith({ mediaSlug: mediaSlug }, null, options)];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
function searchWith(source, imageToken, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        function post(payload) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4, SearchAPIV2Service.searchByImage(__assign(__assign({}, payload), { crop: (_a = options.crop) !== null && _a !== void 0 ? _a : null, threshold: options.threshold, filter: (_b = options.filter) !== null && _b !== void 0 ? _b : null }))];
                        case 1: return [2, _c.sent()];
                    }
                });
            });
        }
        var reused, response, _c, e_2, data, e_3, isLook, image, thumb, _d, e_4, downscaled, e2_1;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    reused = 'mediaSlug' in source ? { imageToken: imageToken, mediaSlug: source.mediaSlug } : { imageToken: imageToken };
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 8, , 9]);
                    if (!(imageToken !== null)) return [3, 3];
                    return [4, post(reused)];
                case 2:
                    _c = _f.sent();
                    return [3, 5];
                case 3: return [4, post(source)];
                case 4:
                    _c = _f.sent();
                    _f.label = 5;
                case 5:
                    response = _c;
                    if (!(response.status === 404 && imageToken !== null)) return [3, 7];
                    sessionStorage.removeItem(IS_IMAGE_TOKEN);
                    return [4, post(source)];
                case 6:
                    response = _f.sent();
                    _f.label = 7;
                case 7: return [3, 9];
                case 8:
                    e_2 = _f.sent();
                    return [2, { status: 'error' }];
                case 9:
                    if (!(response.status === 402)) return [3, 11];
                    _e = { status: 'payment_required' };
                    return [4, readDenial(response)];
                case 10: return [2, (_e.denial = _f.sent(), _e)];
                case 11:
                    if (response.status === 429) {
                        return [2, { status: 'quota_exceeded' }];
                    }
                    if (response.status === 503) {
                        return [2, { status: 'unavailable' }];
                    }
                    if (response.status !== 200) {
                        return [2, { status: 'error' }];
                    }
                    _f.label = 12;
                case 12:
                    _f.trys.push([12, 14, , 15]);
                    return [4, response.json()];
                case 13:
                    data = _f.sent();
                    return [3, 15];
                case 14:
                    e_3 = _f.sent();
                    return [2, { status: 'error' }];
                case 15:
                    if (!data.searchToken) {
                        return [2, { status: 'error' }];
                    }
                    isLook = 'mediaSlug' in source;
                    image = isLook ? data.imageUrl : source.image;
                    if (!isLook) return [3, 16];
                    _d = (_a = data.thumbnailUrl) !== null && _a !== void 0 ? _a : image;
                    return [3, 18];
                case 16: return [4, makeThumbnail(image, THUMBNAIL_MAX_SIZE, (_b = options.crop) !== null && _b !== void 0 ? _b : null)];
                case 17:
                    _d = _f.sent();
                    _f.label = 18;
                case 18:
                    thumb = _d;
                    try {
                        sessionStorage.setItem(IS_SEARCH_TOKEN, data.searchToken);
                        sessionStorage.setItem(IS_THUMB, thumb);
                    }
                    catch (e) {
                        sessionStorage.setItem(IS_SEARCH_TOKEN, data.searchToken);
                    }
                    if (data.imageToken) {
                        try {
                            sessionStorage.setItem(IS_IMAGE_TOKEN, data.imageToken);
                        }
                        catch (e) {
                            sessionStorage.removeItem(IS_IMAGE_TOKEN);
                        }
                    }
                    else {
                        sessionStorage.removeItem(IS_IMAGE_TOKEN);
                    }
                    _f.label = 19;
                case 19:
                    _f.trys.push([19, 20, , 25]);
                    sessionStorage.setItem(IS_IMAGE, image);
                    return [3, 25];
                case 20:
                    e_4 = _f.sent();
                    _f.label = 21;
                case 21:
                    _f.trys.push([21, 23, , 24]);
                    return [4, makeThumbnail(image, STORED_IMAGE_FALLBACK_MAX_SIZE)];
                case 22:
                    downscaled = _f.sent();
                    sessionStorage.setItem(IS_IMAGE, downscaled);
                    return [3, 24];
                case 23:
                    e2_1 = _f.sent();
                    sessionStorage.removeItem(IS_IMAGE);
                    return [3, 24];
                case 24: return [3, 25];
                case 25:
                    if (options.crop) {
                        try {
                            sessionStorage.setItem(IS_CROP, JSON.stringify(options.crop));
                        }
                        catch (e) {
                            sessionStorage.removeItem(IS_CROP);
                        }
                    }
                    else {
                        sessionStorage.removeItem(IS_CROP);
                    }
                    if (isLook) {
                        sessionStorage.setItem(IS_MEDIA_SLUG, source.mediaSlug);
                    }
                    else {
                        sessionStorage.removeItem(IS_MEDIA_SLUG);
                    }
                    return [2, { status: 'ok', searchToken: data.searchToken }];
            }
        });
    });
}
function readDenial(response) {
    return __awaiter(this, void 0, void 0, function () {
        var data, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, response.json()];
                case 1:
                    data = _a.sent();
                    return [2, toImageSearchDenial(data === null || data === void 0 ? void 0 : data.error)];
                case 2:
                    e_5 = _a.sent();
                    return [2, null];
                case 3: return [2];
            }
        });
    });
}
export function rememberImageSearchResume() {
    try {
        localStorage.setItem(IS_RESUME, JSON.stringify({
            url: window.location.pathname + window.location.search,
            at: Date.now(),
        }));
    }
    catch (e) {
    }
}
export function resumeImageSearchAfterValidation() {
    var _a;
    var params = new URLSearchParams(window.location.search);
    if (params.get('message') !== 'email_validated') {
        return;
    }
    params.delete('message');
    var query = params.toString();
    var currentUrl = window.location.pathname + (query ? "?" + query : '');
    window.history.replaceState(window.history.state, '', currentUrl + window.location.hash);
    var resume = null;
    try {
        resume = JSON.parse((_a = localStorage.getItem(IS_RESUME)) !== null && _a !== void 0 ? _a : 'null');
        localStorage.removeItem(IS_RESUME);
    }
    catch (e) {
        return;
    }
    var url = typeof (resume === null || resume === void 0 ? void 0 : resume.url) === 'string' ? resume.url : '';
    var isSameSiteUrl = url.charAt(0) === '/' && url.charAt(1) !== '/';
    var isFresh = typeof (resume === null || resume === void 0 ? void 0 : resume.at) === 'number' && Date.now() - resume.at <= RESUME_TTL_MS;
    if (!isSameSiteUrl || !isFresh) {
        return;
    }
    if (!markImageSearchOpenOnLoad()) {
        return;
    }
    if (url !== currentUrl) {
        window.location.assign(url);
    }
}
export var IMAGE_SEARCH_OPEN_EVENT = 'image_search.open';
export function requestImageSearchOpen() {
    return !window.dispatchEvent(new Event(IMAGE_SEARCH_OPEN_EVENT, { cancelable: true }));
}
export function markImageSearchOpenOnLoad() {
    try {
        sessionStorage.setItem(IS_OPEN_ON_LOAD, '1');
        return true;
    }
    catch (e) {
        return false;
    }
}
export function consumeImageSearchOpenOnLoad() {
    try {
        var pending = sessionStorage.getItem(IS_OPEN_ON_LOAD) === '1';
        sessionStorage.removeItem(IS_OPEN_ON_LOAD);
        return pending;
    }
    catch (e) {
        return false;
    }
}
